import {ActionTypes,  strings,updateLocale, CCAppEventLogger} from './../../cc-imports'

const initialState = {
    fetching: false,
    fetched: false,
    user: {},
    error: null,
    success : false,
    failedCredentials : [],
    random :0,
    anonymous :false
};

const UserReducer = (state = initialState, action = {}) =>{
    switch (action.type) {
        case (ActionTypes.GET_USER) :
            return {...state, fetching : false, fetched : false}
            break;

        case (ActionTypes.getCCFulfilled(ActionTypes.UPDATE_SETTINGS)):
        case (ActionTypes.getCCFulfilled(ActionTypes.UPDATE_USER)):
        case (ActionTypes.getCCFulfilled(ActionTypes.UPDATE_SHOW_HELP)):
            updateLocale(action.payload.data.item.language);
            //I18n.locale=action.payload.data.item.language;
        case (ActionTypes.getCCFulfilled(ActionTypes.GET_USER)):
            CCAppEventLogger.setUserProperties(action.payload.data.item);
            var savedUser = action.payload.data.item;
            //(savedUser && savedUser.settings && savedUser.settings.language && savedUser.settings.language) && (I18n.locale = savedUser.settings.language);
            return {...state, fetching : false, fetched : true, user : action.payload.data.item , success : true, random:Math.random(), anonymous:false}
            break;
        case (ActionTypes.getFulfilled(ActionTypes.GET_USER)):
            return {...state, fetching : false, fetched : true, error: action.payload.data.statusDescription, success : false, random:Math.random()}
            break;
        case (ActionTypes.getPending(ActionTypes.GET_USER)):
            return {...state, fetching : true}
            break;
        case (ActionTypes.getRejected(ActionTypes.GET_USER)):
            return {...state, fetching : false, fetched : true}
            break;

        case (ActionTypes.getCCFulfilled(ActionTypes.GET_OR_CREATE_USER)):
            CCAppEventLogger.setUserProperties(action.payload.data.item);
            updateLocale(action.payload.data.item.language);
            //I18n.locale=action.payload.data.item.language;
            return {...state, fetching : false, fetched : true, user : action.payload.data.item , success : true, random:Math.random(), anonymous:false}
            break;
        case (ActionTypes.getFulfilled(ActionTypes.GET_OR_CREATE_USER)):
            return {...state, fetching : false, fetched : true, error: action.payload.data.statusDescription, success : false, random:Math.random()}
            break;
        case (ActionTypes.getPending(ActionTypes.GET_OR_CREATE_USER)):
            return {...state, fetching : true}
            break;
        case (ActionTypes.getRejected(ActionTypes.GET_OR_CREATE_USER)):
            return {...state, fetching : false, fetched : true}
            break;

        case (ActionTypes.getCCFulfilled(ActionTypes.SIGN_UP_USER)):
            CCAppEventLogger.setUserProperties(action.payload.data.item)
            return {...state, fetching : false, fetched : true, user : action.payload.data.item , success : true, random:Math.random()}
            break;
        case (ActionTypes.getFulfilled(ActionTypes.SIGN_UP_USER)):
            return {...state, fetching : false, fetched : true, error: action.payload.data.statusDescription, success : false}
            break;
        case (ActionTypes.getPending(ActionTypes.SIGN_UP_USER)):
            return {...state, fetching : true}
            break;
        case (ActionTypes.getRejected(ActionTypes.SIGN_UP_USER)):
            return {...state, fetching : false, fetched : true, error : strings('data.reducers.userReducer.something_wrong')}
            break;

        case (ActionTypes.getCCFulfilled(ActionTypes.CREATE_ENTRY)):
            let user = state.user;
            return {...state, fetching : false, fetched : true, user : {...user,coins : user.coins - action.payload.data.item.coins} , success : true, random:Math.random()}
            break;
        case ActionTypes.SAVE_FAILED_CREDENTIALS:
            let failedCredentials = state.failedCredentials;
            failedCredentials.push(action.payload);
            //console.log(failedCredentials);
            return {...state, failedCredentials : failedCredentials}
            break;
        case ActionTypes.SIGN_OUT_USER:
            return initialState;
        case ActionTypes.ANONYMOUS_USER_IN:
            return {...state, random:Math.random(), anonymous:true};
        default :
            return state;
    }
    return state;
};

export default UserReducer;


// WEBPACK FOOTER //
// ./src/app/data/reducers/UserReducers.js